module.exports = __webpack_public_path__ + "img/box_empty.5de19129.png";